// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import { ListItemFactory } from "@app/shared";
import { RoomContentDto } from "@app/catalog";


export class RoomContentModel 
{
    public id: string = "";    
    public name: WritableSignal<string>;
    public code: WritableSignal<string>;
    public category: WritableSignal<string>;
    public thumbnailUrl: WritableSignal<string>;
    public quantity: WritableSignal<number>;
    public isChecked: WritableSignal<boolean>;
    public isActive: WritableSignal<boolean>;
    public hasImageError: WritableSignal<boolean> = signal<boolean>(false);


    constructor()
    {                
        this.name = signal<string>(null);
        this.code = signal<string>(null);      
        this.thumbnailUrl = signal<string>(null);    
        this.quantity = signal<number>(null);    
        this.isChecked = signal<boolean>(false);
        this.isActive = signal<boolean>(false);
    }

    public select(val: boolean) {
        this.isChecked.set(val ? true : false);
    }

    public handleImageError(): void {
        this.hasImageError.set(true);
    }

    public static fromDto(dto: RoomContentDto)
    {
        let roomContent = new RoomContentModel();

        roomContent.id = dto.id;
        roomContent.name.set(dto.name);
        roomContent.code.set(dto.code);
        roomContent.thumbnailUrl.set(dto.thumbnailUrl);
        roomContent.quantity.set(dto.quantity);

        return roomContent;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<RoomContentModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<RoomContentModel>(this.name, this.id, this, selected);    

}
